/* eslint-env browser */
import { Component, Input, OnInit,  OnDestroy, ChangeDetectorRef, ComponentRef, input, output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { Customer } from '@app/models/customers/Customer';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { EncryptionService } from '@app/services/encyption.service';
import { ImportService } from '@app/services/import.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommentComponent } from '../comment/comment.component';
import { FerienHauserService } from '@app/services/ferienhauser/ferienHauser.service';
import { FerienHauserHometogo } from '@app/models/ferienhauser/Ferienhauser';
import moment from 'moment';

@Component({
    selector: 'clever-offerpackedomizilcard',
    templateUrl: './offerpackedomizilcard.component.html',
    styleUrls: ['./offerpackedomizilcard.component.scss'],
    standalone: false
})
export class OfferpackedomizilcardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    readonly offerid = input<string>(undefined);
    @Input() desktopTemplate: string;
    readonly mitEmail = input<string>(undefined);
    readonly index = input<number>(undefined);
    readonly reference = input<string>(undefined);
    readonly mitName = input<string>(undefined);
    readonly mitTel = input<string>(undefined);
    readonly packid = input<string>(undefined);
    readonly online = input<string>(undefined);
    readonly removeFromList = output<string>();
    readonly changeindex = output<{
    dragedindex: number;
    dropindex: number;
}>();

    currentCustomer: Customer;
    currentpartner: Partner;
    component: ComponentRef<any>;

    showDetail: boolean = false;
    showImmages: boolean = true;
    endtDate: string = '';

    sendRegSub: Subscription;
    sendBack: Subscription;
    ferienHauser: FerienHauserHometogo;
    images: any[];
    datas;
    constructor(
        private auth: AuthService,
        private authguad: AuthGuardService,
        private importService: ImportService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private encservice: EncryptionService,
        private router: Router,
        protected ferienService: FerienHauserService,
        protected mediaObserver: BreakpointObserver
    ) {
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();

        this.sendRegSub?.unsubscribe();
        this.sendBack?.unsubscribe();
    }

    ngOnInit(): void {
        this.initMedia();
        this.initCustomer();
        this.initPartner();
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        const index = this.index();
        if (Number(dragedindex) > 0 && Number(dragedindex) !== index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: index - 1 });
        }
    }

    async initCustomer() {
        this.auth.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    async initPartner() {
        this.authguad.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.currentpartner = partner;
            if (this.currentpartner?.partnerid?.length > 0) {
                this.initData();
            }
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initData() {
        const target = {
            offerid: this.offerid(),
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'getofferbyid').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res && !res.error) {
                this.datas = res;
                this.getFerienHauser();
            }
            this.cdr.detectChanges();
        });
    }

    async getFerienHauser() {
        // console.log(this.datas)
        this.ferienService.request({
            apikey: this.currentpartner?.hometogo?.apikey,
            origin: this.currentpartner?.hometogo?.origin,
            id: this.datas.id,
            arrival: this.datas.arrival,
            duration: Number(this.datas.duration),
            adults: this.datas.adults,
            children: this.datas.children,
            childrenAges: this.datas.childrenAges,
        }, 'getObj').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(val => {
            // console.log(val);
            if (val) {
                this.ferienHauser = val;
                this.endtDate = moment(this.datas.arrival).add(this.datas.duration, 'days').format('YYYY-MM-DD');
                this.getimages();
                this.cdr.detectChanges();
            }
        });
    }

    async getimages() {
        if (this.ferienHauser?.images?.length > 0) {
            this.images = [];
            for (let i = 0; i < this.ferienHauser.images.length; i++) {
                this.images.push(this.ferienHauser.images[i].large);
            }

            if (this.images?.length > 0 && this.datas.firstBilder?.length > 0) {
                const pos = this.images.indexOf(this.datas.firstBilder);
                this.images = this.changeBilderPos(this.images, pos);
            }
        }
        this.cdr.detectChanges();
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async gotoBuchen() {
        const params: FerienFIlters = {} as FerienFIlters;
        params.obj_id = this.ferienHauser.id;
        params.start = this.ferienHauser?.price?.arrival;
        params.end = moment(params.start).add(Number(this.datas.duration), 'days').format('YYYY-MM-DD');
        const navigationExtras: NavigationExtras = {
            queryParams: { params: this.encservice.encrypt(params) }
        };
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['ferienhauser-offer'], navigationExtras)
        );
        const link = document.createElement('a');
        link.target = '_blank';
        link.href = url;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: null,
                images: this.images,
                videos: [],
                current: ev,
                to800: false,
                desktopTemplate: this.desktopTemplate,
                showSave: true
            }
        }
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((pos) => {
            if (pos !== this.datas.firstBilderPos) {
                this.datas.firstBilderPos = pos;
                this.saveImagesList();
            }
        });
    }

    openDetail() {
        this.gotoBuchen();
    }

    saveImagesList() {
        const target = {
            offerid: this.offerid(),
            firstBilder: this.images[this.datas.firstBilderPos],
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'updateImageList').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                // console.log(res);
            } else {
                if (this.images) {
                    this.images = this.changeBilderPos(this.images, this.datas.firstBilderPos);
                    this.showImmages = false;
                    this.datas.firstBilderPos = 0;
                    this.cdr.detectChanges();
                    setTimeout(() => {
                        this.showImmages = true;
                        this.cdr.detectChanges();
                    });
                }
            }
            this.cdr.detectChanges();
        });
    }

    changeBilderPos(targetArray, pos): string[] {
        if (targetArray?.length > 0) {
            targetArray.splice(0, 0, targetArray[pos]);
            targetArray.splice(pos + 1, 1);
        }
        return targetArray;
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }

    async openSetComment() {
        let target = {} as MatDialogConfig;
        if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
            target = {
                width: '600px',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            };
        } else {
            target = {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                // panelClass: 'customModal',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            }
        }
        const resf = this.dialog.open(CommentComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data) {
                this.datas.extracomment = data?.message;
                this.saveComment(this.datas.extracomment);
            }
        });
    }

    saveComment(extracomment) {
        const target = {
            offerid: this.offerid(),
            extracomment: extracomment,
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'saveComment').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                console.log(res);
            }
        });
    }
}
